import { getCartId } from "src/tracking/state"
import { TrackingOrder } from "src/tracking/types"
import { KlarCartEvent, KlarCheckoutEvent, KlarOrderEvent } from "./types"

export function klarDebug(...args: unknown[]) {
  console.debug("🟪 klar:", ...args)
}

function klarPush<T extends object>(name: `Klar:send${string}Event`, data: T) {
  klarDebug(name)

  window._k_q ||= window._k_q || []
  window._k_q.push([name, data])
}

export function klarTrackCartEvent() {
  klarPush("Klar:sendUpdateCartEvent", { cartId: getCartId() } satisfies KlarCartEvent)
}

export function klarTrackCheckoutEvent() {
  klarPush("Klar:sendUpdateCheckoutEvent", { checkoutId: getCartId() } satisfies KlarCheckoutEvent)
}

export function klarTrackOrderEvent(order: TrackingOrder) {
  klarPush("Klar:sendOrderEvent", { orderId: order.transactionId } satisfies KlarOrderEvent)
}
